import { configureStore, combineReducers } from "@reduxjs/toolkit";

import { persistReducer, persistStore } from "redux-persist";

import storage from "redux-persist/lib/storage";

import authReducer from "../features/auth/authSlice";
// // settings
import settings from "../features/settings/Slice";

import { api } from "../features/api";

const persistConfig = {
  key: "root",
  storage,

  whitelist: ["auth"],
};

const rootReducer = combineReducers({
  auth: authReducer,
  settings,

  [api.reducerPath]: api.reducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(api.middleware),
});

export const persistor = persistStore(store);
